export { LinkBoard, TextBoard } from './BoardDetail';
